import { StyleSheet } from "react-native";
import { color2, dpToPx } from "src/styles";
import { font } from "src/styles/themes";

export const styles = () =>
  StyleSheet.create({
    title: {
      color: color2.BLUE_DARK,
      fontFamily: font.family.fromVariable,
      fontSize: font.size.header,
      lineHeight: dpToPx(40),
    },
    subtitle: {
      color: color2.GRAY4,
      fontFamily: font.family.fromVariable,
      fontSize: font.size.caption,
      marginTop: dpToPx(24),
      lineHeight: dpToPx(24),
    },
    wrapper: {
      flex: 1,
      padding: dpToPx(24),
    },
    content: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      minHeight: dpToPx(86),
    },
  });
